export default "__VITE_ASSET__Bhxjvcjg__"